import * as tslib_1 from "tslib";
import { DefaultMaterialManager } from "@awayjs/graphics";
import { DiffuseBasicChunk } from "./DiffuseBasicChunk";
/**
 * DiffuseGradientChunk is an alternative to DiffuseBasicChunk in which the shading can be modulated with a gradient
 * to introduce color-tinted shading as opposed to the single-channel diffuse strength. This can be used as a crude
 * approximation to subsurface scattering (for instance, the mid-range shading for skin can be tinted red to similate
 * scattered light within the skin attributing to the final colour)
 */
var DiffuseGradientChunk = (function (_super) {
    tslib_1.__extends(DiffuseGradientChunk, _super);
    /**
     * Creates a new DiffuseGradientChunk object.
     * @param gradient A texture that contains the light colour based on the angle. This can be used to change
     * the light colour due to subsurface scattering when the surface faces away from the light.
     */
    function DiffuseGradientChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    DiffuseGradientChunk.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        this._gradient = this._shader.getAbstraction(this._method.gradient || DefaultMaterialManager.getDefaultTexture());
    };
    /**
     * @inheritDoc
     */
    DiffuseGradientChunk.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
        this._pIsFirstLight = true;
        return code;
    };
    /**
     * @inheritDoc
     */
    DiffuseGradientChunk.prototype._getFragmentCodePerLight = function (lightDirReg, lightColReg, registerCache, sharedRegisters) {
        var code = "";
        var t;
        // write in temporary if not first light, so we can add to total diffuse colour
        if (this._pIsFirstLight)
            t = this._totalLightColorReg;
        else {
            t = registerCache.getFreeFragmentVectorTemp();
            registerCache.addFragmentTempUsages(t, 1);
        }
        code += "dp3 " + t + ".w, " + lightDirReg + ".xyz, " + sharedRegisters.normalFragment + ".xyz\n" +
            "mul " + t + ".w, " + t + ".w, " + sharedRegisters.commons + ".x\n" +
            "add " + t + ".w, " + t + ".w, " + sharedRegisters.commons + ".x\n" +
            "mul " + t + ".xyz, " + t + ".w, " + lightDirReg + ".w\n";
        if (this._modulateFunction != null)
            code += this._modulateFunction(t, registerCache, sharedRegisters);
        code += this._gradient._getFragmentCode(t, registerCache, sharedRegisters, t) +
            //					"mul " + t + ".xyz, " + t + ".xyz, " + t + ".w\n" +
            "mul " + t + ".xyz, " + t + ".xyz, " + lightColReg + ".xyz\n";
        if (!this._pIsFirstLight) {
            code += "add " + this._totalLightColorReg + ".xyz, " + this._totalLightColorReg + ".xyz, " + t + ".xyz\n";
            registerCache.removeFragmentTempUsage(t);
        }
        this._pIsFirstLight = false;
        return code;
    };
    /**
     * @inheritDoc
     */
    DiffuseGradientChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        this._gradient.activate();
    };
    /**
     * @inheritDoc
     */
    DiffuseGradientChunk.prototype._setRenderState = function (renderable, projection) {
        _super.prototype._setRenderState.call(this, renderable, projection);
        this._gradient._setRenderState(renderable);
    };
    return DiffuseGradientChunk;
}(DiffuseBasicChunk));
export { DiffuseGradientChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/DiffuseGradientChunk.js